<template lang="pug">
div
  v-dialog(v-model='dialog' max-width="1700px" @click:outside='closeDialog()')
    v-card
      v-toolbar.toolbar-settings.text-settings(style='z-index: 99999')
        v-spacer
        v-btn#closeIcon(icon color='white' @click='closeDialog')
          md-icon close
      .md-layout.mt-4
        .md-layout-item.ml-auto
          md-button.md-warning(
            style='float: right;'
            @click='addRecipient()'
          )
            v-icon(style='color: black !important; padding-right: 4px;') mdi-plus
            span(style='color: black')
              | {{$t('campaign.addRecipient')}}
      .md-layout
        .md-layout-item.md-size-100.mx-auto(style='padding: 0')
          DataProvider(:endpoint='endpoint', :filter='filter' ref='dataProvider' :key="componentKey")
            div(slot-scope='{ data: response, error, loading }')
              DataTable(
                v-if='response && response.data'
                :data='response && response.data'
                ref='dataTable'
                :title="$t('campaign.recipientsList')"
                :customTotal='(response && response.total) || 0'
                @pagination='handlePagination'
                :currentSort.sync='filter.orderBy',
                :currentSortOrder.sync='filter.order',
                :selectable='false'
                :loading='loading'
                customHeader
                :endpoint='endpoint'
                :labels='labels'
                :filter='filter'
                :formatLabelFunction='formatLabels'
                csvComponentId="csv-recipient-list"
                fileName='recipients_list'
                orientationPDF="landscape"
                :createHeader='createHeaderPDF')
                template(slot="custom-filter")
                  v-text-field(style='float: right; margin-right: 19px; width: 30%;margin-top: 20px; margin-left: 10px;'
                    :placeholder="$t('table.enterWordOrDataForTheSearch')"
                    hide-details
                    filled
                    dense
                    :value='search'
                    @input='updateSearch'
                  )
                template(slot='footer' slot-scope='{ pagination }')
                  v-row(style='justify-content: flex-end;')
                    v-col(cols='auto')
                      md-field
                        label(for='pages') {{ $t('commonPhrases.perPage') }}
                        md-select(v-model='pagination.perPage' name='pages' )
                          md-option(
                            v-for='item in pagination.perPageOptions',
                            :key='item',
                            :label='item',
                            :value='item')
                            | {{ item }}
                template(slot='cells' slot-scope='{ item }')
                  md-table-cell(:md-label='labels[0]')
                    md-switch(disabled v-model="item._source.active")
                  md-table-cell(:md-label='labels[1]') {{ formatLabels(item, 1) }}
                  md-table-cell(:md-label='labels[2]') {{ formatLabels(item, 2) }}
                  md-table-cell(:md-label='labels[3]') {{ formatLabels(item, 3) }}
                  md-table-cell(:md-label='labels[4]') {{ formatLabels(item, 4) }}
                  md-table-cell(:md-label='labels[5]') {{ formatLabels(item, 5) }}
                  md-table-cell(:md-label='labels[6]') {{ formatLabels(item, 6) }}
                  md-table-cell(:md-label='labels[7]') {{ formatLabels(item, 7) }}
                  md-table-cell(:md-label='labels[8]') {{ formatLabels(item, 8) }}
                  md-table-cell(:md-label='labels[9]') {{ formatLabels(item, 9) }}
                  md-table-cell(:md-label="$t('campaign.actions')")
                    v-row(no-gutters style='justify-content: flex-end;')
                      v-col(cols='auto' style='padding: 4px; margin: 8px 0;')
                        v-btn(
                          class="mx-2"
                          x-small
                          fab
                          dark
                          color="#4caf50"
                          @click='editRecipient(item)'
                        )
                          v-icon(dark)
                            | create
                        md-tooltip(md-direction="bottom")
                          | {{$t('commonWords.edit')}}
                      v-col(cols='auto' style='padding: 4px; margin: 8px 0;')
                        v-btn(
                          @click='deleteRecipient(item)'
                          style='margin-right: 3px'
                          class="mx-2"
                          x-small
                          fab
                          dark
                          color="#f44336"
                        )
                          v-icon(dark )
                            | delete
                        md-tooltip(md-direction="bottom")
                          | {{$t('commonWords.delete')}}
  template(v-if="recipientsDialog")
    NotificationRecipientsListDialog(
      :dialog.sync='recipientsDialog'
      :item='item'
      :templateId='selectedTemplate.id'
      :key="selectedTemplate.id"
      @rerender='forceRerender'
      :campaignId='campaignId'
    )
</template>

<script>
import * as moment from 'moment'
import Swal from 'sweetalert2'
import debounce from 'lodash/debounce'
import Pagination from '@/components/Pagination.vue'
import DataTable from '@/components/DataTable.vue'
import DataProvider from '@/components/DataProvider'
import NotificationRecipientsListDialog from './NotificationRecipientsListDialog.vue'
import { selectedLocale } from '@/plugins/i18n'
import { mapFields } from 'vuex-map-fields'

export default {
  components: {
    Pagination,
    DataTable,
    DataProvider,
    NotificationRecipientsListDialog
  },
  computed: {
    ...mapFields('campaign', ['selectedTemplate']),
    endpoint () {
      return `${process.env.VUE_APP_BACKEND_BASE_URL}/campaign/${this.campaignId}/contacts`
    }
  },
  props: {
    dialog: {
      type: Boolean
    },
    campaignId: {
      type: String
    }
  },
  data () {
    return {
      recipientsDialog: false,
      item: {},
      componentKey: 0,
      labels: [
        'Status',
        this.$t('commonWords.createdAt'),
        this.$t('campaign.username'),
        this.$t('testNotificationDialog.senderSMS'),
        this.$t('testNotificationDialog.receiverSMS'),
        this.$t('campaign.senderWhatsapp'),
        this.$t('campaign.receiverWhatsapp'),
        this.$t('campaign.senderTeams'),
        this.$t('campaign.receiverTeams'),
        this.$t('commonWords.updatedAt')],
      filter: {
        order: 'asc',
        orderBy: 'createdAt',
        page: 0,
        perPage: 5
      },
      search: ''
    }
  },
  methods: {
    closeDialog () {
      this.$emit('update:dialog', false)
      this.selectedTemplate = {
        id: undefined
      }
      this.item = {}
    },
    forceRerender () {
      this.componentKey += 1
      this.$emit('rerender')
    },
    formatLabels (item, i) {
      switch (i) {
        case 0:
          return item._source.active ? this.$t('commonWords.enabled') : this.$t('commonWords.disabled')
        case 1:
          return this.formatDate(item, 'createdAt')
        case 2:
          return item._source.name
        case 3:
          return this.getInfoChannel(item, 'senderSMS')
        case 4:
          return this.getInfoChannel(item, 'receiverSMS')
        case 5:
          return this.getInfoChannel(item, 'senderWhatsapp')
        case 6:
          return this.getInfoChannel(item, 'receiverWhatsapp')
        case 7:
          return this.getInfoChannel(item, 'senderTeams')
        case 8:
          return this.getInfoChannel(item, 'receiverTeams')
        case 9:
          return this.formatDate(item, 'updatedAt')
        default:
          break
      }
    },
    formatDate (item, type) {
      let date = item._source[type]
      return moment(date).locale(selectedLocale).format('L LT')
    },
    getInfoChannel (item, column) {
      switch (column) {
        case 'senderWhatsapp' :
          return item._source.contacts.find(channel => channel.channel === 'whatsapp')?.from
        case 'receiverWhatsapp' :
          return item._source.contacts.find(channel => channel.channel === 'whatsapp')?.to
        case 'senderTeams' :
          return item._source.contacts.find(channel => channel.channel === 'teams')?.from
        case 'receiverTeams' :
          return item._source.contacts.find(channel => channel.channel === 'teams')?.to
        case 'senderSMS' :
          return item._source.contacts.find(channel => channel.channel === 'sms')?.from
        case 'receiverSMS' :
          return item._source.contacts.find(channel => channel.channel === 'sms')?.to
        default:
          break
      }
    },
    addRecipient () {
      this.item = {}
      this.recipientsDialog = true
    },
    deleteRecipient (item) {
      const id = item._id
      Swal.fire({
        icon: 'warning',
        title: this.$t('commonPhrases.areYouSure'),
        text: this.$t('commonPhrases.youWillNotBeAble'),
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: this.$t('commonWords.cancel'),
        confirmButtonClass: 'md-button md-success btn-fill',
        cancelButtonClass: 'md-button md-danger btn-fill',
        confirmButtonText: this.$t('commonPhrases.yesDelete'),
        buttonsStyling: false
      }).then(async (result) => {
        if (result.value) {
          try {
            await this.$axios.delete(`/campaign/${this.campaignId}/contacts/${id}`)
            Swal.fire({
              title: this.$t('campaign.deleted'),
              text: `${this.$t('campaign.youDeleted')} ${item._source.name}`,
              type: 'success',
              icon: 'success',
              showConfirmButton: false,
              timer: 1500
            })
            setTimeout(() => {
              this.forceRerender()
              this.$emit('rerender')
            }, 2000)
          } catch (error) {
            Swal.fire({
              icon: 'error',
              title: this.$t('commonWords.error'),
              html: `${error}`
            })
          }
        }
      })
    },
    editRecipient (item) {
      this.recipientsDialog = true
      this.item = item
    },
    updateSearch: debounce(function (value) {
      this.filter.search = value
      this.$refs.dataProvider.load()
    }, 400),
    createHeaderPDF (doc, total) {
      doc.setFontSize(14)
      doc.setFont(undefined, undefined, '700')
      doc.text(15, 10, this.$t('campaign.recipientsList'))

      doc.setFontSize(10)
      doc.setFont('times', undefined, '700')
      doc.text(15, 17, this.$t('chatTable.timeCourse'))
      doc.setFont('times', undefined, '300')

      let formattedDate1 = moment(this.filter.from).locale(selectedLocale).format('L LTS')
      let formattedDate2 = moment(this.filter.to).locale(selectedLocale).format('L LTS')
      doc.text(29, 17, `${formattedDate1} até ${formattedDate2}`)

      doc.setFont('times', undefined, '700')
      doc.text(15, 22, 'Total')
      doc.setFont(undefined, undefined, '300')
      doc.text(46, 22, `${total}`)

      const tableOffsetY = 30
      return tableOffsetY
    },
    handlePagination (pagination, oldPagination) {
      const newFilter = {}
      const { currentPage, perPage } = pagination
      if (currentPage && this.filter.page !== currentPage - 1) {
        newFilter.page = currentPage - 1
      }
      if (perPage && this.filter.perPage !== perPage) {
        newFilter.perPage = perPage
      }
      Object.assign(this.filter, newFilter)
    }
  },
  watch: {
    dialog (value) {
      if (value) {
        this.$nextTick(() => {
          if (this.$refs.dataProvider) {
            this.$refs.dataProvider.load()
          }
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>

  ::v-deep .md-table-head:first-child {
    width: 85px;
  }

  ::v-deep .md-table-head-label {
    font-size: 15px !important;
  }

  ::v-deep .md-card {
    box-shadow: none !important;
  }

</style>
